import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
import { FileArrowDown } from 'phosphor-react'
import { formatDate, getHours } from '../../lib/lib'

const CommentWrapper = styled.div`
    padding-top: 20px;
`

const Head = styled.div`
    display: flex;
    justify-content: space-between;
    .from {
        font-weight: 600;
        color: #2D0F19;
    }
    .date {
        color: #7E7E7E;
    }
`

const Comment = styled.div`
    padding-top: 10px;
    color: #7E7E7E;
`

const Attachments = styled.div`
    display: flex;
    padding-top: 10px;
`

const File = styled.div`
    display: flex;
    align-items: center;
    padding-right: 10px;
    span {
        padding-left: 4px;
    }
    &:hover {
        cursor: pointer;
    }
`

class HomeworkComment extends Component {
    constructor(props) {
        super(props)
        this.state = {
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
    }

    render() {
        const { t } = this.props
        return (
            <CommentWrapper>
                <Head>
                    {
                        this.props.from === 'user' ?
                            <span className='md-font-size from'>{t('homework-user')}</span> :
                            <span className='md-font-size from'>{t('homework-teacher')}</span>
                    }
                    <span className='md-font-size date'>{`${formatDate(this.props.date)} ${getHours(this.props.date)}`}</span>
                </Head>
                <Comment className='md-font-size'>
                    {this.props.comment}
                </Comment>
                <Attachments className={!this.props.files || !this.props.files.length ? 'p-0' : ''}>
                    {
                        this.props.files && this.props.files.length ?
                            this.props.files.map((file, index) => (
                                <File
                                    key={`file-${index}`}
                                    onClick={() => window.open(`${this.state.imageUrl}/${file}`, "_blank")}
                                >
                                    <FileArrowDown size={16} />
                                    <span className='sm-font-size'>{t('homework')}</span>
                                </File>
                            )) : ''
                    }
                </Attachments>
            </CommentWrapper >
        )
    }
}

HomeworkComment.propTypes = {
    t: PropTypes.func,
    history: PropTypes.object,
    from: PropTypes.string,
    date: PropTypes.string,
    comment: PropTypes.string,
    files: PropTypes.array,
}


export default withTranslation()(HomeworkComment)


// WEBPACK FOOTER //
// ./src/components/Study/Comment.jsx